module.exports = __webpack_public_path__ + "static/media/dashboard.caa32bd4.svg";